// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { featuredCategoriesStyles } from "@tps/App/Widgets/FeaturedCategories/FeaturedCategories";
import { GridOffset } from "@tps/MobiusOverrides/GridContainer/GridContainer";
import { css } from "styled-components";

featuredCategoriesStyles.categoryCardsGridContainer = {
    css: css`
        ${GridOffset} {
            justify-content: center;
        }
    `,
};

featuredCategoriesStyles.categoryCardGridItem = {
    width: [6, 3, 3, (12 / 5) as any, (12 / 5) as any],
};
